import { CARE_ORDER_BABY_TYPE, } from '@/interface/domain/careOrderBaby';
import { useRouter } from '@/util/hook/custom';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import useState from '@/util/hook/useState';
import { selectLiffId } from '@/util/redux/auth';
import { orderAPI } from '@/api/careClient';
import { COMMON_ROUTES } from '@/config/route';
import { selectCareOrderBabyForm } from '../../redux/module/careOrderBabyForm';
export const useCalculateTimeSlotFee = ({ setApiProcessingPool, setApiDonePool, }) => {
    const [timeSlotFeeData, setTimeSlotFeeData] = useState(null);
    const { navigateError } = useRouter();
    const _id = useSelector(selectLiffId);
    const careOrderBabyForm = useSelector(selectCareOrderBabyForm);
    const initialType = careOrderBabyForm.initialType;
    const servedItem = careOrderBabyForm.servedItem;
    const symptom = careOrderBabyForm.symptom;
    const hospitalBed = careOrderBabyForm.hospitalBed;
    const timeSlotList = careOrderBabyForm.timeSlotList;
    const isAllDay = initialType === CARE_ORDER_BABY_TYPE.ALL_DAY;
    const isMockApiMode = (process.env.ENV.TARGET_ENV === 'local' || process.env.ENV.TARGET_ENV === 'dev') &&
        process.env.ENV.TEST_SCENARIO;
    useEffect(() => {
        (async () => {
            const shouldRun = servedItem && symptom && hospitalBed && timeSlotList.length > 0;
            if (!shouldRun)
                return;
            let timeSlot;
            // #NOTES
            // Since all the timeSlots share the same expectedServiceDays and expectedServiceHours,
            // we take the first one as the base.
            if (isAllDay) {
                const baseTimeSlot = timeSlotList[0];
                const allDayTimeSlot = {
                    expectedServiceDays: baseTimeSlot.expectedServiceDays,
                    expectedServiceHours: null,
                };
                timeSlot = allDayTimeSlot;
            }
            else {
                const baseTimeSlot = timeSlotList[0];
                const partTimeTimeSlot = {
                    expectedServiceDays: null,
                    expectedServiceHours: baseTimeSlot.expectedServiceHours,
                };
                timeSlot = partTimeTimeSlot;
            }
            const res = await orderAPI.TimeSlotFeeCalculate({
                _id,
                careOrderId: null,
                careOrderData: {
                    initialType,
                    servedItem,
                    symptom,
                    hospitalBed,
                },
                timeSlot,
                ...(isMockApiMode && {
                    initialType,
                }),
            }, setApiProcessingPool, setApiDonePool);
            if (res.success && res.data) {
                setTimeSlotFeeData(res.data);
            }
            else {
                navigateError(res.errorCode, COMMON_ROUTES.API_ERROR);
            }
        })();
    }, [initialType, servedItem, symptom, hospitalBed, timeSlotList]);
    return { timeSlotFeeData };
};
